import { BaseError } from "./base-error.js";
export class UnauthorizedError extends BaseError {
    static code = 'UnauthorizedError';
    static statusCode = 401;
    constructor(message = 'Unauthorized Error', options = {}) {
        super(message, options);
    }
}
